// extracted by mini-css-extract-plugin
export var container = "_t2-0";
export var inputWidth = "_t2-1";